export interface Metadata {
    type: string;
}

export interface VersionMetadata extends Metadata {
    version: string;
}

export function isVersionMetadata(metadata: Metadata | null): metadata is VersionMetadata {
    if (!metadata) {
        return false;
    }
    return metadata.type === 'TravelTimeMetadata' || metadata.type === 'RoadSectionMeasurementMetadata' || metadata.type === 'LocationMeasurementMetadata';
}
